<template>
  <div class="row">
    <div class="col-12">
      <h2>Introdução</h2>
      <p>
        <strong>"Viña Concha y Toro"</strong> Reconhece a importância e o valor da informação para uma gestão eficiente e eficaz, constituindo um fator critico e estratégico para o sucesso da Empresa, e sua projecção  no tempo. Também considera informação utilizada pela empresa em seus negócios, o resultado do esforço e investimento que fornecem à empresa uma vantagem competitiva. Portanto realiza um programa de segurança da informação, que inclui a utilização de um aviso de "Declaração  de delimitação de responsabilidade" na parte inferior de cada e-mail enviado da companhia.
      </p>
      <h2>Declaração de delimitação de responsabilidade</h2>
      <p>
        A informação transmitida, incluindo os arquivos anexos, destina-se apenas a pessoa ou entidade destinada e pode conter informação confidencial e/ou privilegiada. Qualquer revisão, retransmissão, divulgação ou qualquer outro é proibido, excluindo-nos de qualquer responsabilidade decorrente do conteúdo. Se você recebeu este e-mail por engano, por favor, entre em contato com o remetente e apague o material de qualquer computador.
      </p>
      <p>
        <strong>"Viña Concha y Toro"</strong> Não é responsável de forma alguma por erros ou omissões contidos no envio de e-mails, Nem é responsável por danos decorrentes de qualquer modificação que não tenha sido devidamente autorizada na mensagem ou em seus anexos.
      </p>
      <p>
        <strong>"Viña Concha y Toro"</strong> Não garante que esta mensagem está livre de vírus de computador, portanto, não se responsabiliza por danos causados pelos mesmos e que pode ser ter sido encaminhadas no conteúdo do e-mail.
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'HomePt'
  }
</script>



// WEBPACK FOOTER //
// src/components/HomePt.vue